
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BlogPost } from '@/services/blog/types';

interface BlogMetaTagsProps {
  post: BlogPost;
}

export const BlogMetaTags: React.FC<BlogMetaTagsProps> = ({ post }) => {
  return (
    <Helmet>
      <title>{post.meta_title || post.title} | The Mat Monster</title>
      <meta name="description" content={post.meta_description || post.summary || `Read about ${post.title}`} />
      <meta property="og:title" content={post.title} />
      <meta property="og:description" content={post.summary || `Read about ${post.title}`} />
      <meta property="og:type" content="article" />
      {post.featured_image && <meta property="og:image" content={post.featured_image} />}
      <meta property="article:published_time" content={post.published_at || ''} />
      <meta property="article:author" content={post.author?.full_name || post.author?.username || 'The Mat Monster'} />
      {post.tags?.map(tag => (
        <meta property="article:tag" content={tag} key={tag} />
      ))}
    </Helmet>
  );
};
